// Exporting this way as vue.config.js need the value too
module.exports = {
  dev: {
    primary: '#009688',
    secondary: '#757575',
    // Default Pri Color / Secondary
    // primary: '#1976D2',
    // secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  demo: {
    // Maverick Color
    primary: '#009688',
    secondary: '#757575',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  uoi: {
    // UOI Color
    primary: '#002469',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  ecics: {
    // Ecics Color
    primary: '#00ADEF',
    secondary: '#757575',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
}
